import React from 'react';
import { Building2, MapPin, Shield, Database, FileCheck } from 'lucide-react';

const Facts = () => {
  const facts = [
    {
      icon: Building2,
      number: '1000',
      unit: 'm²',
      label: 'Modernaus sandėlio',
      color: 'blue'
    },
    {
      icon: MapPin,
      text: 'Strateginė vieta',
      label: 'Ateities pl. 28 c, Kaunas',
      color: 'green'
    },
    {
      icon: Shield,
      text: 'Saugumas',
      label: 'Aptverta teritorija ir signalizacija',
      color: 'red'
    },
    {
      icon: Database,
      text: 'WMS sistema',
      label: 'Sandėlio valdymo sistema',
      color: 'purple'
    },
    {
      icon: FileCheck,
      text: 'Draudimas',
      label: 'Atsargų draudimas',
      color: 'orange'
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white" data-testid="facts-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Faktai, kuriais galite pasitikėti
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Mūsų infrastruktūra ir profesionalumas užtikrina jūsų verslo sėkmę
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {facts.map((fact, index) => {
            const Icon = fact.icon;
            return (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 text-center hover:bg-white/20 transition-all"
                data-testid={`fact-card-${index}`}
              >
                <div className="inline-flex items-center justify-center bg-white/20 p-3 rounded-full mb-4">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                {fact.number ? (
                  <div className="mb-2">
                    <span className="text-4xl font-bold">{fact.number}</span>
                    <span className="text-2xl ml-1">{fact.unit}</span>
                  </div>
                ) : (
                  <h3 className="text-xl font-bold mb-2">{fact.text}</h3>
                )}
                <p className="text-blue-100 text-sm">{fact.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Facts;
